export const GET_VEHICLE_GROUPS = "GET_VEHICLE_GROUPS";

export const UPDATE_VEHICLE_GROUPS_AFTER_ALLOCATE = "UPDATE_VEHICLE_GROUPS_AFTER_ALLOCATE";